import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pdf-toolbar',
  templateUrl: './pdf-toolbar.component.html',
  styleUrls: ['./pdf-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PdfToolbarComponent {
  @Input() currentPage = 1;
  @Input() totalPages = 0;

  @Output() pageChange = new EventEmitter<number>();

  prev(): void {
    if (this.currentPage > 1) {
      this.pageChange.emit(this.currentPage - 1);
    }
  }

  next(): void {
    if (this.currentPage < this.totalPages) {
      this.pageChange.emit(this.currentPage + 1);
    }
  }

  goToPage(rawValue: string | number): void {
    const value = Math.trunc(Number(rawValue));
    if (!Number.isFinite(value)) return;
    const clamped = Math.min(Math.max(value, 1), Math.max(this.totalPages, 1));
    if (clamped !== this.currentPage) {
      this.pageChange.emit(clamped);
    }
  }
}
